// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonPrimary_button__2oPks"};